/**
 * Persistente analytics-cookietoestemming (localStorage).
 */
export const ANALYTICS_CONSENT_STORAGE_KEY = 'todoes.analyticsConsent';

/** @typedef {'accepted' | 'rejected'} AnalyticsConsentValue */

/**
 * @returns {AnalyticsConsentValue | null}
 */
export function getAnalyticsConsent() {
  try {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    const raw = localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY);
    if (raw === 'accepted' || raw === 'rejected') {
      return raw;
    }
    return null;
  } catch {
    return null;
  }
}

/**
 * @param {AnalyticsConsentValue} value
 * @returns {boolean} false als opslaan niet lukt
 */
export function setAnalyticsConsent(value) {
  try {
    if (typeof localStorage === 'undefined') {
      return false;
    }
    localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, value);
    return true;
  } catch {
    return false;
  }
}

/**
 * @returns {boolean}
 */
export function hasAnalyticsConsentDecision() {
  return getAnalyticsConsent() !== null;
}
